<template>
  <div class="pa-16">
    <span style="color: gray; font-size: 30px; font-weight: bold">
      Article Review
    </span>
    <v-divider class="mt-3" />
    <v-row class="mt-8" justify="center">
      <v-col cols="6">
        <v-card class="pa-4" outlined>
          <v-card-title>
            <span style="color: gray; font-weight: bold">
              {{ title }}
            </span>
          </v-card-title>
          <v-card-subtitle>
            <v-divider />
          </v-card-subtitle>
          <v-card-text>
            <span style="color: black">
              {{ abstract }}
            </span>
            <div class="mt-5">
              <span style="color: black; font-weight: bold"> Keywords: </span>
              <span
                style="color: black"
                v-for="(k, index) in keywords"
                :key="k"
              >
                {{ k }}{{ index >= keywords.length - 1 ? "" : "," }}
              </span>
            </div>
          </v-card-text>
          <v-card-actions class="mt-8">
            <v-spacer />
            <v-btn
              outlined
              large
              @click="openPdf()"
              id="revision-open-pdf-button"
            >
              Open PDF
              <v-icon color="error"> {{ icon.mdiFilePdfBox }} </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-container style="height: 100%">
          <v-select
            id="revision-approval-select"
            :items="items"
            v-model="editStatus"
            label="Approval status"
            outlined
          ></v-select>
          <div>
            <v-textarea
              id="revision-comments-input"
              outlined
              label="Comments"
              v-model="editComment"
            ></v-textarea>
          </div>
          <v-row class="ml-1 mr-1">
            <v-spacer />
            <v-btn
              id="revision-cancel-button"
              outlined
              color="error"
              @click="$parent.$parent.$parent.step--"
            >
              Cancel
            </v-btn>
            <v-btn
              id="revision-save-button"
              color="success"
              class="ml-4"
              @click="submit()"
            >
              Send
            </v-btn>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiFilePdfBox } from "@mdi/js";
import paper from "@/helpers/paperStatus.js";

export default {
  props: {
    title: String,
    abstract: String,
    keywords: Array,
    download: String,
    status: String,
    comment: String,
    review: Object,
    step: Number,
    paper: Object,
  },
  data: () => ({
    icon: {
      mdiFilePdfBox,
    },
    editStatus: "",
    editComment: "",
    items: [
      "Accepted",
      "Rejected",
      "Accepted with Revision",
      "More Reviews",
      "Rejected with Revision",
      "Unassigned",
      "Under Review",
    ],
  }),
  methods: {
    async submit() {
      this.$emit("submit");
      this.$emit("setLoading", true);
      this.review.status = this.editStatus;
      this.review.review = this.editComment;

      let newPaper = {};

      //construct newPaper without id
      Object.keys(this.paper).forEach((key) => {
        if (key !== "id") newPaper[key] = this.paper[key];
      });

      await this.$store
        .dispatch("updatePaper", {
          id: this.paper.id,
          data: newPaper,
        })
        .then(() => {
          this.$store.dispatch("updateChangeLogs", {
            paperId: this.paper.id,
            log: {
              label: `${
                paper.changeLog("", this.$store.state.auth.user.displayName)[
                  "newReview"
                ].label
              }`,
              datetime: new Date().toLocaleString("en-US"),
            },
          });
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Revision submitted succesfully!",
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Oops... Error updating review",
            color: "error",
          });
          console.error("Error updating paper review ", err);
        });

      this.$emit("setLoading", false);
    },
    async openPdf() {
      let url = await this.$store.dispatch("getPaperPdf", {
        name: this.paper.id,
      });

      window.open(url);
    },
  },
  watch: {
    step() {
      this.editStatus = this.review.status;
      this.editComment = this.review.review;
    },
  },
  mounted() {
    this.editStatus = this.review.status;
    this.editComment = this.review.review;
  },
};
</script>
